<template>
    <b-overlay :show="mapLoading" bg-color="transparent" blur="2px">
        <!-- LOADING OVERLAY -->
        <template #overlay>
            <div v-if="mapLoading" class="text-center py-3">
                <img src="@/assets/lottie/plant.gif" alt="Loading..." style="width: 40px;" />
            </div>
        </template>
        <b-card no-body class="rounded-xl mb-5">
            <b-card-header class="border-2 border-bottom px-5 pt-0 pb-3 d-flex align-items-center" v-if="title">
                <h3>{{ title }}</h3>
            </b-card-header>
            <!-- CONTENT -->
            <b-card-body class="p-0">
                <div class="map-wrapper" style="height: 400px; width: 100%; position: relative;">
                    <template v-if="!isMapLoaded">
                        <div
                            class="d-flex align-items-center justify-content-center"
                            style="height: 100%; width: 100%; background: rgba(0,0,0,0.2); border-radius: 10px; overflow: hidden;"
                        >
                            <div
                            class="buka-map-btn text-center py-3 px-4 bg-light text-primary rounded shadow-sm"
                            style="cursor: pointer;"
                            @click="loadMap"
                            >
                            Buka Maps
                            </div>
                        </div>
                    </template>

                    <div
                    v-else
                    ref="mapContainer"
                    style="height: 100%; width: 100%; border-radius: 10px;"
                    ></div>
              </div>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
export default {
  name: "base-map-coordinate",
  components: {
  },
  props: {
    title: { type: String, default: null },
    coordinate_data: { type: Object, default: {latitude: -7.024947, longitude: 110.414672} },
  },
  data() {
    return {
      mapLoading: false,
      maps: null,
      isMapLoaded: false,
    };
  },

  mounted() {
  },
  methods: {
    async publicLoadMap() {
      this.loadMap();
    },
    async loadMap() {
      console.log('map loaded!')
      this.mapLoading = true;
      this.isMapLoaded = true;
      this.$nextTick(async () => {
        if (!this.coordinate_data || !this.coordinate_data.latitude || !this.coordinate_data.longitude) {
          return;
        }
        await this.initializeMap();
      });
      this.mapLoading = false;
    },
    async initializeMap() {
      console.log('map initialize!')
      let mapLatitude = this.coordinate_data.latitude || null;
      let mapLongitude = this.coordinate_data.longitude || null;

      if (!mapLatitude || !mapLongitude) {
        this.$_alert.info(`Tidak ada data koordinat!`);
        return;
      }

      this.maps = new mapboxgl.Map({
        accessToken: this.$_config.apikey.mapbox,
        container: this.$refs.mapContainer,
        style: "mapbox://styles/mapbox/satellite-streets-v12",
        center: [mapLongitude, mapLatitude],
        zoom: 12,
        projection: "globe",
      });

      this.maps.addControl(new mapboxgl.NavigationControl());
      this.maps.addControl(new mapboxgl.FullscreenControl());

      new mapboxgl.Marker({ color: "red" })
        .setLngLat([mapLongitude, mapLatitude])
        .addTo(this.maps);
    },
  },
  
};
</script>
<style>
.map-placeholder {
  background: url('https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/110.4, -7.02,9,0/800x400?access_token=YOUR_MAPBOX_KEY') center/cover no-repeat;
  filter: blur(5px) brightness(0.8);
}
</style>


// WEBPACK FOOTER //
// src/base/component/base-map-coordinate.vue